import {
  GET_SETTING_COIN,
  GET_SETTING_COIN_SUCCESS,
  GET_SETTING_COIN_FAILED,
  UPDATE_SETTING_COIN,
  UPDATE_SETTING_COIN_SUCCESS,
  UPDATE_SETTING_COIN_FAILED,
  GET_HISTORY_COIN,
  GET_HISTORY_COIN_SUCCESS,
  GET_HISTORY_COIN_FAILED,
} from './actionTypes';

export const actionGetSettingCoin = (payload) => ({
  payload,
  type: GET_SETTING_COIN,
});

export const actionGetSettingCoinSuccess = (payload) => ({
  payload,
  type: GET_SETTING_COIN_SUCCESS,
});

export const actionGetSettingCoinFailed = (payload) => ({
  payload,
  type: GET_SETTING_COIN_FAILED,
});

export const actionUpdateSettingCoin = (payload) => ({
  payload,
  type: UPDATE_SETTING_COIN,
});

export const actionUpdateSettingCoinSuccess = (payload) => ({
  payload,
  type: UPDATE_SETTING_COIN_SUCCESS,
});

export const actionUpdateSettingCoinFailed = (payload) => ({
  payload,
  type: UPDATE_SETTING_COIN_FAILED,
});

export const actionGetHistoryCoin = (payload) => ({
  payload,
  type: GET_HISTORY_COIN,
});

export const actionGetHistoryCoinSuccess = (payload) => ({
  payload,
  type: GET_HISTORY_COIN_SUCCESS,
});

export const actionGetHistoryCoinFailed = (payload) => ({
  payload,
  type: GET_HISTORY_COIN_FAILED,
});
